import React, { useEffect, useState } from "react";
import { Profile as ProfileAPI, getSetting } from "../API/admin";
import { WaitlistPlayersAPI, getPlayerSportsLatest } from "../API/player";

import CIcon from "@coreui/icons-react";
import { cilPencil } from "@coreui/icons";
import { CButton } from "@coreui/react";
import ChangePassword from "./modal/ChangePassword";
import Profileupdate from "./modal/profileupdate";
import Withdrwal from "./modal/Withdrawal";
import { useSnackbar } from "notistack";
import Loader from "../views/admin/Common/Loader";

const Profile = () => {
  const [user, setUser] = useState([]);
  const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE;
  const [visible, setVisible] = useState(false);
  const [isparticipant, setIsparticipant] = useState(false);
  const [withdrawal, setwithdrwal] = useState(false);
  const [waitingPlayer, setWaitingPlayer] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [Sports, setSports] = useState([]);
  let [loaderStatus, setloaderStatus] = useState(true);

  const [IsOn, setIsOn] = useState(null);

  useEffect(() => {
    callAPI();
    callAPI2();
    callAPI3();
    callAPI4();
  }, []);

  let callAPI = async () => {
    let res = await ProfileAPI();
    if (res.status) {
      setUser(res.data);
      setIsparticipant(res.data.role === "participant" ? true : false);
      setloaderStatus(false);
    } else {
      setloaderStatus(false);
    }
  };

  let callAPI2 = async () => {
    let res = await getSetting();

    if (res.status) {
      res.data.map((entry, index) => {
        if (entry.name === "withdrawal") setwithdrwal(entry.value);
      });
    } else {
      setIsOn(null);
      enqueueSnackbar("unable to fetch setting", {
        variant: "error",
        action: (key) => (
          <button
            className="toast_close_btn"
            onClick={() => {
              // Close the Snackbar
              closeSnackbar(key);
            }}
          >
            X
          </button>
        ),
      });
    }
  };

  let callAPI3 = async () => {
    let formdataa = {};
    let res = await WaitlistPlayersAPI(formdataa);
    if (res.data.totalRecords == 1) {
      setWaitingPlayer(true);
    }
  };

  let callAPI4 = async () => {
    let res = await getPlayerSportsLatest();

    if (res.data.status) {
      const availableSports = res.data.data.sports.filter(
        (sport) => !res.data.data.withdrawan_sports.includes(sport)
      );
      setSports(availableSports);
    }
  };

  //  My profile Cards colors handling acordingly user role
  let profile_card_bg,
    profile_text_color,
    profile_box_border_color,
    text_muted_color_admin,
    profile_btn_color;
  if (user) {
    switch (user.role) {
      case "participant":
        profile_card_bg = "#040405";
        profile_text_color = "#fff";
        profile_box_border_color = "#D9D9D9";
        text_muted_color_admin = "#fff";
        profile_btn_color = "#B2022F";
        break;
      case "admin":
        profile_card_bg = "";
        profile_text_color = "";
        profile_box_border_color = "";
        text_muted_color_admin = "";
        profile_btn_color = "rgb(88 86 214)";
        break;
      case "scorer":
        profile_card_bg = "#040405";
        profile_text_color = "#fff";
        profile_box_border_color = "#D9D9D9";
        text_muted_color_admin = "#fff";
        profile_btn_color = "#B2022F";
        break;
      default:
        profile_card_bg = "";
        profile_text_color = "";
        profile_box_border_color = "";
        text_muted_color_admin = "";
        profile_btn_color = "";
        break;
    }
  } else {
    profile_card_bg = "#fff";
    profile_text_color = "";
    profile_box_border_color = "";
    text_muted_color_admin = "";
    profile_btn_color = "";
  }

  const formatTitle = (text) => {
    return text
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };
  console.log(user.role);
  return (
    <>
      {loaderStatus ? <Loader /> : null}
      <section className="pb-5">
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-4">
              <div
                className="card mb-4"
                style={{
                  backgroundColor: profile_card_bg,
                  borderColor: profile_box_border_color,
                }}
              >
                <div className="card-body text-center">
                  <img
                    src={
                      user.profile_image
                        ? `${IMAGE_URL}user/${user.profile_image}`
                        : `${IMAGE_URL}blank_user.png`
                    }
                    alt="user_img"
                    className="img-fluid"
                    style={{
                      width: "135px",
                      height: "135px",
                      borderRadius: "50%",
                      marginTop: "10px",
                      objectFit: "cover",
                    }}
                  />
                  <h5 className="my-3" style={{ color: profile_text_color }}>
                    {user.fname + " " + user.lname}
                  </h5>
                  <p className="mb-1" style={{ color: text_muted_color_admin }}>
                    {user.role}
                  </p>
                  <p className="mb-3" style={{ color: text_muted_color_admin }}>
                    United Premier Games
                  </p>
                  {/* <ChangePassword onClick={() => setVisible(true)} visble={visible} ></ChangePassword>
                                    <p className="mt-1" style={{ color: profile_text_color }}> Change Password</p> */}
                  <div>
                    <Profileupdate user_details={user}></Profileupdate>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div
                className="card mb-4"
                style={{
                  backgroundColor: profile_card_bg,
                  borderColor: profile_box_border_color,
                }}
              >
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0" style={{ color: profile_text_color }}>
                        Full Name
                      </p>
                    </div>
                    <div className="col-sm-9">
                      <p
                        className="mb-0"
                        style={{ color: text_muted_color_admin }}
                      >
                        {user.fname + " " + user.lname}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0" style={{ color: profile_text_color }}>
                        Email
                      </p>
                    </div>
                    <div className="col-sm-9">
                      <p
                        className="mb-0"
                        style={{ color: text_muted_color_admin }}
                      >
                        {user.email}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0" style={{ color: profile_text_color }}>
                        Username
                      </p>
                    </div>
                    <div className="col-sm-9">
                      <p
                        className="mb-0"
                        style={{ color: text_muted_color_admin }}
                      >
                        {user.username}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0" style={{ color: profile_text_color }}>
                        Team
                      </p>
                    </div>
                    <div className="col-sm-9">
                      <p
                        className="mb-0"
                        style={{ color: text_muted_color_admin }}
                      >
                        {user.corporate_email
                          ? formatTitle(user.corporate_email)
                          : "N/A"}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-sm-3">
                      <p className="mb-0" style={{ color: profile_text_color }}>
                        Gender
                      </p>
                    </div>
                    <div className="col-sm-9">
                      <p
                        className="mb-0"
                        style={{ color: text_muted_color_admin }}
                      >
                        {user.gender}
                      </p>
                    </div>
                  </div>

                  {isparticipant ? (
                    <>
                      <hr />
                      <div className="row">
                        <div className="col-sm-3">
                          <p
                            className="mb-0"
                            style={{ color: profile_text_color }}
                          >
                            Sports
                          </p>
                        </div>
                        <div className="col-sm-9">
                          {Sports.length > 0 ? (
                            <>
                              <p
                                className="mb-0"
                                style={{ color: text_muted_color_admin }}
                              >
                                {Sports.map((entry, index) => (
                                  <>
                                    {entry == "table_tenis"
                                      ? "Table Tennis"
                                      : entry == "2k_run"
                                      ? "2k Run"
                                      : entry == "badminton"
                                      ? "Badminton"
                                      : "bowling"}
                                    {index + 1 != Sports.length
                                      ? Sports.length > 1
                                        ? ", "
                                        : null
                                      : null}
                                  </>
                                ))}
                              </p>
                            </>
                          ) : (
                            <p style={{ color: text_muted_color_admin }}>N/A</p>
                          )}
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
              {/* <div className="d-flex justify-content-between"> */}
              {/* <div>
                                    {
                                        isparticipant && withdrawal === "true" && Sports.length > 0 ? (

                                            <Withdrwal visible={true}> </Withdrwal>
                                        ) : null
                                    }
                                </div> */}
              {/* </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Profile;
